import { render, staticRenderFns } from "./breakfast-order.vue?vue&type=template&id=7904278c"
import script from "./breakfast-order.vue?vue&type=script&lang=ts"
export * from "./breakfast-order.vue?vue&type=script&lang=ts"
import style0 from "./breakfast-order.vue?vue&type=style&index=0&id=7904278c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports